import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  CustomPresentationGroup,
  GetCurrentEveUserCustomPresentationGroupsGQL,
} from '../../generated/eveportal-api/graphql';

export interface CustomPresentationGroupResult {
  items: CustomPresentationGroup[];
  totalCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class CustomPresentationGroupService {
  constructor(
    private getCurrentEveUserCustomPresentationGroupsGQL: GetCurrentEveUserCustomPresentationGroupsGQL
  ) {}

  getCustomPresentationGroups(
    skip = 0,
    take = 10
  ): Observable<CustomPresentationGroupResult> {
    return this.getCurrentEveUserCustomPresentationGroupsGQL
      .fetch({}, { fetchPolicy: 'network-only' })
      .pipe(
        map((result: any) => {
          const data = result.data?.currentEveUserCustomPresentationGroups;
          return {
            items: data?.items || [],
            totalCount: data?.totalCount || 0,
          };
        })
      );
  }

  // Helper method to get all custom presentation groups without pagination
  getAllCustomPresentationGroups(): Observable<CustomPresentationGroup[]> {
    return this.getCustomPresentationGroups(0, 50).pipe(
      map((result) => [
        ...result.items,
        {
          customPresentationGroupId: -1,
          name: 'DDI',
          presentationNumber: 'DDI',
          organisationNode: null,
        },
        {
          customPresentationGroupId: -2,
          name: 'Switchboard',
          presentationNumber: 'Switchboard',
          organisationNode: null,
        },
        {
          customPresentationGroupId: -3,
          name: 'Anonymous',
          presentationNumber: 'Anonymous',
          organisationNode: null,
        },
      ] as CustomPresentationGroup[])
    );
  }
}